/** Types */
import { BydGenericModel } from './byd-generic-model.type';
import 'reflect-metadata';
import { BYD_CLEAN_INSTANCE_KEY } from '../constants/byd-clean-instance-key.constant';

/**
 * `BydCleanInstance`
 *
 * A class decorator factory
 * override the super constructor to
 * returns a new instance of the super model T without the undefined properties.
 *
 * @param SuperModel the super constructor `<T>`
 * @returns BydGenericModel<T>
 */
export function BydCleanInstance<T>(SuperModel: BydGenericModel<T>) {
  /**
   * We use regular function since are constructible and callable.
   *
   * @param args the super model properties
   * @returns superModelInstance
   */
  const superConstructor = function (...args: T[]) {
    const superModelInstance: T = new SuperModel(...args);
    let cleanedValues = Reflect.getMetadata(BYD_CLEAN_INSTANCE_KEY, SuperModel);
    if (!Array.isArray(cleanedValues) || !cleanedValues.length) cleanedValues = [cleanedValues];

    Object.keys(superModelInstance).forEach((propertyKey: string) => {
      const attributeValue = JSON.stringify(superModelInstance[propertyKey]);

      cleanedValues.forEach((value) => {
        const cleanedValue = JSON.stringify(value);

        if (attributeValue === cleanedValue) {
          delete superModelInstance[propertyKey];
        }
      });
    });
    return superModelInstance;
  };
  return <BydGenericModel<T>>(<unknown>superConstructor);
}
